import React, { useState } from "react";
import { ReactComponent as TimeIcon } from '../assets/icons/TimeIcon.svg'

const CalendarModal = ({ isVisible, onClose, onDateSelect, showTimeInput = true }) => {
const [currentDate, setCurrentDate] = useState(new Date());
const [selectedDay, setSelectedDay] = useState(null);
const [selectedTime, setSelectedTime] = useState("");

const getDaysInMonth = (year, month) => {
const date = new Date(year, month, 1);
const days = [];
while (date.getMonth() === month) {
days.push(new Date(date));
date.setDate(date.getDate() + 1);
}
return days;
};

const getStartingDay = (year, month) => {
const date = new Date(year, month, 1);
return date.getDay();
};

const daysOfWeek = ["D", "L", "M", "M", "J", "V", "S"];

const renderCalendar = () => {
const today = new Date();
const year = currentDate.getFullYear();
const month = currentDate.getMonth();
const daysInMonth = getDaysInMonth(year, month);
const startingDay = getStartingDay(year, month);
const calendarDays = [];

for (let i = 0; i < startingDay; i++) {
calendarDays.push(
<div key={`empty-${i}`} className="calendar-day empty"></div>
);
}

daysInMonth.forEach((day, index) => {
const isToday =
day.getDate() === today.getDate() &&
day.getMonth() === today.getMonth() &&
day.getFullYear() === today.getFullYear();

const isSelected = selectedDay && 
day.getDate() === selectedDay.getDate() &&
day.getMonth() === selectedDay.getMonth() &&
day.getFullYear() === selectedDay.getFullYear();

const dayClass = `calendar-day ${isToday ? "today" : ""} ${isSelected ? "selected" : ""}`;

calendarDays.push(
<div 
key={index} 
className={dayClass}
onClick={() => setSelectedDay(day)}
>
{day.getDate()}
</div>
);
});
return calendarDays;
};

const goToPreviousMonth = () => {
setCurrentDate(
new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
);
};

const goToNextMonth = () => {
setCurrentDate(
new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1)
);
};


const handleTimeChange = (e) => {
let value = e.target.value.replace(/\D/g, ""); 


if (value.length > 2) {
value = value.slice(0, 2) + ":" + value.slice(2, 4);
}


if (value.length > 5) {
value = value.slice(0, 5);
}

setSelectedTime(value);
};

const handleDoneClick = () => {
if (!selectedDay) return;

let finalDate = new Date(selectedDay);


const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/; 

if (selectedTime && timeRegex.test(selectedTime)) {
const [hours, minutes] = selectedTime.split(":");
finalDate.setHours(hours);
finalDate.setMinutes(minutes);
} else {
finalDate.setHours(0, 0, 0, 0); 
}

onDateSelect(finalDate);
onClose();
};

const modalClass = `calendar-modal-overlay ${isVisible ? "visible" : ""}`;

return (
<div className={modalClass}>
<div className="calendar-modal-content">
<div className="calendar-container">
<div className="calendar-navigation">
<button onClick={goToPreviousMonth}>&lt;</button>
<span>
{currentDate.toLocaleString("es-ES", {
month: "long",
year: "numeric",
})}
</span>
<button onClick={goToNextMonth}>&gt;</button>
</div>
<div className="calendar-header">
{daysOfWeek.map((day, index) => (
<div key={index} className="day-of-week">
{day}
</div>
))}
</div>
<div className="calendar-grid">{renderCalendar()}</div>
</div>

{showTimeInput && (
<div className="time-input-container">
<TimeIcon className="time-input-icon"/>
<input
id="task-time"
type="text" 
placeholder="Establecer hora" 
value={selectedTime}
onChange={handleTimeChange}
className="task-time-input"
/>
</div>)}

<div className="modal-actions">
<button  onClick={onClose} className="modal-close-button">
Cancelar
</button>
<button onClick={handleDoneClick} className="done-button">
Hecho
</button>
</div>
</div>
</div>
);
};


export default CalendarModal;